export const accountResources = {
  'account.yourAccountSettings': 'La configuración de su cuenta',
  'account.firstName': 'Nombre de Pila',
  'account.lastName': 'Apellido',
  'account.email': 'Email',
  'account.role': 'Oficio',
  'account.resetPassword': 'Restablecer la Contraseña',
  'account.editInfo': 'Editar información',
  'account.resetPasswordConfirmation': '¿Estás segura de que quieres restablecer tu contraseña?',
  // TODO(EURO-23): replace with compliance-approved Spanish copy.
  'account.login.privacyBanner.title': 'We Value Your Privacy',
  'account.login.privacyBanner.body':
    'We use essential cookies to ensure basic site functionality and enhance platform security. By continuing to log in to this site, you consent to our use of cookies and acknowledge our {privacyPolicy}, which outlines our data privacy practices and cookie usage.',
  'account.login.privacyBanner.privacyPolicy': 'Privacy Policy',
};

export type AccountResourceKey =
  | 'account.yourAccountSettings'
  | 'account.firstName'
  | 'account.lastName'
  | 'account.email'
  | 'account.role'
  | 'account.resetPassword'
  | 'account.editInfo'
  | 'account.resetPasswordConfirmation'
  | 'account.login.privacyBanner.title'
  | 'account.login.privacyBanner.body'
  | 'account.login.privacyBanner.privacyPolicy';
